// Form inputs
import { MpfFormFieldConfig } from '../../lib/components/MpfForm/MpfForm.props';

export const inputReporterType: MpfFormFieldConfig = {
  modelValue: null,
  name: 'reporterType',
  type: 'radios',
  label: 'Who is the request for?',
  legendHeadingSize: 'l',
  items: [
    { label: 'Me', value: 'PATIENT', type: 'radio' },
    { label: 'Someone else', value: 'PROXY', type: 'radio' },
  ],
  required: true,
};

export const inputFirstName: MpfFormFieldConfig = {
  name: 'firstName',
  label: 'First name',
  hint: 'As it would appear on medical records',
  type: 'text',
  required: true,
};
export const inputLastName: MpfFormFieldConfig = {
  name: 'lastName',
  label: 'Last name',
  type: 'text',
  required: true,
};
export const inputRelationshipToPatient: MpfFormFieldConfig = {
  name: 'relationshipToPatient',
  label: 'Relationship to patient',
  type: 'text',
  required: true,
};

export const inputPostcode: MpfFormFieldConfig = {
  name: 'postcode',
  label: 'Postcode',
  type: 'postcode',
  required: true,
};

export const inputDateOfBirth: MpfFormFieldConfig = {
  name: 'dateOfBirth',
  label: 'Date of birth',
  hint: 'For example, 15 3 1984',
  type: 'dateOfBirth',
  required: true,
  legendFontWeight: 'normal',
  legendHeadingSize: 's',
};

// TODO: make text areas
export const inputProblemDescription: MpfFormFieldConfig = {
  name: 'problemDescription',
  label: 'Tell us about your health concern in your own words',
  hint: "For example, when it started, any changes, worries, how it affects your day, or the help you're hoping for",
  type: 'textarea',
  required: true,
  headingLevelSize: 's',
  rows: 5,
};

export const inputAttachments: MpfFormFieldConfig = {
  modelValue: [],
  name: 'attachments',
  label: 'Attachments',
  hint: 'Attachments will be added to your clinical record and may be seen by male or female staff.',
  type: 'attachments',
  required: false,
  headingLevelSize: 'l',
  maxFileSize: 5 * 1024 * 1024,
};

export const inputProblemRecentContact: MpfFormFieldConfig = {
  name: 'problemRecentContact',
  label:
    'Include details of any recent contact with a healthcare professional about your concern (optional)',
  hint: 'For example, who you spoke to and any advice or treatment',
  type: 'textarea',
  required: false,
  headingLevelSize: 's',
  rows: 5,
};

export const inputAdminRequest: MpfFormFieldConfig = {
  name: 'adminRequest',
  label: 'Please describe your request',
  type: 'textarea',
  required: true,
  headingLevelSize: 's',
  rows: 5,
};

export const inputVerificationCode: MpfFormFieldConfig = {
  name: 'verificationCode',
  label: 'Verification code',
  hint: 'It should be 6 digits',
  type: 'text',
  required: true,
  errors: ['Verification code is required'],
};

export const inputAvailablePrescriptions: MpfFormFieldConfig = {
  modelValue: null,
  name: 'availablePrescriptions',
  type: 'checkboxes',
  label: 'Repeat medications',
  hint: 'You can choose more than one option.',
  items: [],
  required: false,
};

export const inputAvailableAcutePrescriptions: MpfFormFieldConfig = {
  modelValue: null,
  name: 'availablePrescriptionsAcute',
  type: 'checkboxes',
  label: 'Past acute medications (6 months)',
  hint: 'You can choose more than one option.',
  items: [],
  required: false,
};
